import { PageSection as Section } from '@superhi/design'
import React from 'react'
import pick from 'lodash.pick'
import { OptionValue as SelectOptionValue } from '@superhi/design/src/components/forms/inputs/SelectInput/SelectInput'

import Filters, { Props as FiltersProps } from '../Filters'
import Pagination, { Props as PaginationProps } from '../Pagination'

import { getQuery } from './utils'

type Props<F extends { [K in keyof F]: SelectOptionValue }> = Pick<
  FiltersProps<F, any>,
  'name' | 'filters' | 'isLoading'
> & {
  query: FiltersProps<F, any>['query'] & PaginationProps['query']
  children: React.ReactElement
  perPage: number
  numResults?: number
}

function Results<F extends { [K in keyof F]: SelectOptionValue }>({
  filters,
  numResults = 0,
  isLoading,
  query,
  children,
  perPage,
  name,
}: Props<F>) {
  const filterKeys = React.useMemo(() => Object.keys(filters), [filters])

  return (
    <>
      <Section collapseTopPadding noBottomPadding>
        <Filters<F, any>
          name={name}
          numResults={numResults}
          filters={filters}
          query={pick(query, filterKeys)}
          isLoading={isLoading}
        />
      </Section>

      {children}

      <Pagination numResults={numResults} perPage={perPage} query={query} />
    </>
  )
}

export { getQuery }
export default Results
